<template>
    <section class="monitoringProviderOdf">
        <stack-received />
        <stack v-if ="archived" :directory="archived" :name="'Archived'" :path="'Archived'"/>
    </section>
</template>

<script>
import Stack from '@/components/monitoring/provider/odf/Stack'
import StackReceived from '@/components/monitoring/provider/odf/StackReceived'

export default {
  name: 'monitoringProviderOdf',
  components: { StackReceived, Stack },
  computed: {
    archived () { return this.$store.getters['ProviderOdf/filesArchived'] }
  }
}
</script>

<style>
.monitoringProviderOdf{
  flex:1 1 auto
}
</style>
